/**
 * Redemption Types
 * All types related to reward redemption and swaps
 */
/**
 * Order verifier type
 */
export var OrderVerifier;
(function (OrderVerifier) {
    OrderVerifier["GELATO"] = "gelato";
    OrderVerifier["RUNTIME"] = "runtime";
})(OrderVerifier || (OrderVerifier = {}));
/**
 * Runtime task status
 */
export var TaskStatus;
(function (TaskStatus) {
    TaskStatus["SUCCEEDED"] = "SUCCEDDED";
    TaskStatus["PROCESSING"] = "PROCESSING";
    TaskStatus["FAILED"] = "FAILED";
    TaskStatus["ABANDONED"] = "ABANDONED";
    TaskStatus["INCOMPLETE"] = "INCOMPLETE";
    TaskStatus["PENDING"] = "PENDING";
    TaskStatus["FULFILLED"] = "FULLFILLED";
    TaskStatus["CANCELLED"] = "CANCELLED";
})(TaskStatus || (TaskStatus = {}));
